import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';

const Head = () => {
  const { t } = useTranslation();

  return (
    <Helmet>
      <meta name="viewport" content="initial-scale=1, width=device-width" />
      <title>Incentivio | {t('AppWrapper.head.title')}</title>
    </Helmet>
  );
};
export default Head;
